// extracted by mini-css-extract-plugin
export default {"MoviesByGenresDiv":"MoviesByGenres_MoviesByGenresDiv__myNrd","MoviesByGenres":"MoviesByGenres_MoviesByGenres__oPCUo"};